var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "form-group", class: _vm.computedClasses },
    [
      _c("vue-timepicker", {
        class: _vm.inputClasses,
        attrs: {
          "input-class": [..._vm.inputClasses, { "form-control": true }],
          name: _vm.name,
          id: _vm.id,
          format: _vm.format,
          placeholder: _vm.placeholder,
          "auto-scroll": "",
          "close-on-complete": "",
          readonly: _vm.readonly,
          disabled: _vm.disabled,
          required: _vm.required,
        },
        on: {
          focus: function ($event) {
            return _vm.handleFocus(true)
          },
          blur: function ($event) {
            return _vm.handleFocus(false)
          },
          change: _vm.changeHandler,
        },
        model: {
          value: _vm.valueCopy,
          callback: function ($$v) {
            _vm.valueCopy = $$v
          },
          expression: "valueCopy",
        },
      }),
      _vm._v(" "),
      _c(
        "label",
        {
          staticClass: "material-label",
          class: _vm.activeClass,
          attrs: { for: _vm.id },
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _vm.error
        ? _c("small", { staticClass: "invalid-feedback" }, [
            _vm._v(_vm._s(_vm.error)),
          ])
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }